// feature/apple-treatment — hover-intent gate. 300ms-in / 100ms-out prevents flicker when
// the mouse just brushes past rows during scrolling. Returns a focused boolean
// plus mouse handlers to attach to the host element.
import { useEffect, useRef, useState } from "react";

export function useHoverIntent(delayIn = 300, delayOut = 100) {
  const [isFocused, setIsFocused] = useState(false);
  const inT = useRef(null);
  const outT = useRef(null);

  function onMouseEnter() {
    clearTimeout(outT.current);
    inT.current = setTimeout(() => setIsFocused(true), delayIn);
  }
  function onMouseLeave() {
    clearTimeout(inT.current);
    outT.current = setTimeout(() => setIsFocused(false), delayOut);
  }

  useEffect(() => () => {
    clearTimeout(inT.current);
    clearTimeout(outT.current);
  }, []);

  return { isFocused, onMouseEnter, onMouseLeave };
}
